import { Injectable } from '@angular/core';
import { AuthSession } from '@supabase/supabase-js';
import { MultiDeviceSessionService } from '../multi-device-session/multi-device-session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private sessionRequest: Promise<AuthSession | null> | null = null;

  constructor(private multiDeviceSession: MultiDeviceSessionService) {}

  // 合併同時間的查詢；session 一律以 Supabase 保存的為準，不另外快取
  async getSession(): Promise<AuthSession | null> {
    if (!this.sessionRequest) {
      this.sessionRequest = this.multiDeviceSession.getCurrentSession()
        .finally(() => {
          this.sessionRequest = null;
        });
    }

    return this.sessionRequest;
  }

  async signOut(scope: 'local' | 'global' = 'local') {
    try {
      if (scope === 'global') {
        await this.multiDeviceSession.signOutAllDevices();
      } else {
        await this.multiDeviceSession.signOutCurrentDevice();
      }
    } catch (error) {
      console.error(`登出失敗 (${scope}):`, error);
    }
  }

  /**
   * 以帳號密碼登入；每台裝置各自擁有獨立 session。
   */
  async signInWithMultiDevice(phone: string, password: string) {
    return await this.multiDeviceSession.signInWithSessionSharing(phone, password);
  }
}
